export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle input");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const bodyWrap = document.querySelector("body");
	const menuMobileWrap = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");





	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		menuMobileWrap.classList.toggle("is-open");
	});
	closeMenu.addEventListener("click", () => {
		menuMobileWrap.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-bg");
	});

	//back to top
	backTop.addEventListener("click", (event) => {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "300");
	});
	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");
	//Tab function


	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {

				$(this).find(".article").slideUp();
				$(this).removeClass("is-toggle");
			} else {
				$(".toggle-item").find(".article").slideUp();
				$(".toggle-item").removeClass("is-toggle");
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});

	$(".mobile-menu-nav .menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});
	//Tab function
	$(".rolling-text").each(function () {
		const $element = $(this);
		const innerText = $element.text().trim();
		$element.empty();

		const createTextContainer = () =>
			$("<div>")
				.addClass("block")
				.append(
					[...innerText].map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter.trim() === "" ? "\xa0" : letter)
					)
				);

		$element.append(createTextContainer()).append(createTextContainer());
	});


	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: 100,
			limit: function limit() {
				return (
					$(".quick-access-block").offset().top -
					$("header").outerHeight() -
					100
				);
			},
			// Add the class when it becomes absolute (reaches the limit)
			preAbsolute: function () {
				$(this).addClass("reached-limit");
			},
			// Or postAbsolute, depending on exact timing preference
			// postAbsolute: function () {
			//   $(this).addClass("reached-limit");
			// },
			// Remove the class when it becomes fixed again
			preFixed: function () {
				$(this).removeClass("reached-limit");
			},
			// If you need to handle it unfixed above the scroll point
			postUnfixed: function () {
				$(this).removeClass("reached-limit");
			},
		});
	}
	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".scroll-section-wrap .anchor-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					80 -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav li.is-active").removeClass("is-active");
					$(".sticky-nav li").eq(i).addClass("is-active");
				}
			});
		})
		.scroll();
	$(".sticky-nav  a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});

	$("section").each(function () {
		const $section = $(this);
		const $items = $section.find(".tab-item");

		const $active = $items.filter(".active");

		if (!$active.length) {
			$items.first().addClass("active");
			$section.find(".tab-nav li:first").addClass("active");
		}
	});

	$(".tab-nav a").on("click", function (e) {
		e.preventDefault();

		const $nav = $(this).parents(".tab-nav");
		const $section = $(this).parents("section");

		$nav.find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		const tab = $(this).attr("data-type");
		const $items = $section.find(".tab-item");

		$items.removeClass("active");
		$section.find("#" + tab).addClass("active");
	});


	$(".view-more-wrap").each(function () {
		const $wrapper = $(this);
		const initialShow = parseInt($wrapper.data('initial-show') || 4);
		const incrementBy = parseInt($wrapper.data('increment') || 6);

		let currentVisible = initialShow;
		const totalItems = $wrapper.find(".item").length;

		// Show initial items (but don't show more than what exists)
		$wrapper
			.find(".item")
			.slice(0, Math.min(currentVisible, totalItems))
			.show(function () {
				$(this).css("display", "flex");
			});

		// Hide view more button if total items <= initial show amount
		if (totalItems <= initialShow) {
			$wrapper.addClass("disable-btn");
			return; // Exit early since no "view more" functionality is needed
		}

		// Attach click handler to this specific instance
		$wrapper
			.find(".btn-primary")
			.on("click", function (e) {
				e.preventDefault();

				currentVisible += incrementBy;

				$wrapper
					.find(".item")
					.slice(0, currentVisible)
					.slideDown(function () {
						$(this).css("display", "flex");
					});

				// Hide button if all items are now visible
				if (currentVisible >= totalItems) {
					$wrapper.addClass("disable-btn");
				}
			});
	});


	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	try {
		document.querySelectorAll('.wrap-form textarea').forEach(function (textarea) {
			textarea.value = textarea.value.trim();
		});
	} catch (error) {

	}

	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 200,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
